/**
 * FeatureFlagsContext — runtime feature toggles fetched once at boot
 * from `/api/public/feature-flags`. Consumers read via `useFeatureFlag('key')`.
 * Falls back to defaults while the fetch is in flight so nothing flickers.
 */
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';

const DEFAULTS = { directory_v2: false, store_v1: false };

export const FeatureFlagsContext = createContext({ flags: DEFAULTS, ready: false });

export const FeatureFlagsProvider = ({ children }) => {
  const { API } = useContext(AuthContext);
  const [flags, setFlags] = useState(DEFAULTS);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/public/feature-flags`)
      .then((r) => { if (alive) setFlags({ ...DEFAULTS, ...(r.data?.flags || {}) }); })
      .catch(() => { /* keep defaults */ })
      .finally(() => { if (alive) setReady(true); });
    return () => { alive = false; };
  }, [API]);

  return (
    <FeatureFlagsContext.Provider value={{ flags, ready }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlag = (key) => {
  const { flags } = useContext(FeatureFlagsContext);
  return !!flags?.[key];
};

export default FeatureFlagsProvider;
